import React, { useEffect, useState } from "react";

import Icon from "../../../../components/Icon";

// Busca só no Enter ou na lupa: buscar a cada tecla faria uma consulta do
// extrato inteiro por letra digitada.
export const SearchInPeriod = ({ value, onSearch, placeholder = 'Pesquisar' }) => {
    const [text, setText] = useState(value ?? '');

    useEffect(() => {
        setText(value ?? '');
    }, [value]);

    const submit = event => {
        event.preventDefault();
        onSearch(text.trim());
    };

    return (
        <form className="finance-search-in-period" onSubmit={submit}>
            <input
                type="search"
                value={text}
                placeholder={placeholder}
                onChange={event => setText(event.target.value)}
            />
            <button type="submit" aria-label="Pesquisar">
                <Icon name="search" size={18} />
            </button>
        </form>
    );
};

export default SearchInPeriod;
